module.exports = __webpack_public_path__ + "static/media/home.ebe935c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/home.svg
// module id = 1096
// module chunks = 0